var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWashingMachine1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 302.09 359.05",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-10,.cls-26,.cls-27,.cls-28,.cls-36,.cls-39,.cls-40{fill:none;}.cls-2{fill:#fff;}.cls-3{fill:#c8cad1;}.cls-4{fill:#d9e6ed;}.cls-5{fill:#acc6d1;}.cls-6{opacity:0.4;}.cls-7{fill:#343f42;}.cls-24,.cls-29,.cls-8{fill:#8ab3ff;}.cls-8{opacity:0.5;}.cls-17,.cls-8{mix-blend-mode:screen;}.cls-9{fill:#828282;}.cls-10{stroke:#5b6062;}.cls-10,.cls-26,.cls-27,.cls-28,.cls-29,.cls-36,.cls-39,.cls-40{stroke-miterlimit:10;}.cls-11{fill:#99aebc;}.cls-12{fill:#b8c0cc;}.cls-13{fill:#cbd5e4;}.cls-14{fill:#546d75;}.cls-15{fill:#475b64;}.cls-16{fill:#3a4b51;}.cls-17{fill:url(#linear-gradient);}.cls-18{fill:#ccd6e5;}.cls-19{fill:#b8bcc0;}.cls-20{fill:#9caab2;}.cls-21{fill:#b9bdc1;}.cls-22{fill:#1a3447;}.cls-23{fill:#6c8197;}.cls-25{fill:#588df0;}.cls-26{stroke:#588df0;}.cls-27{stroke:#475b64;}.cls-28{stroke:#828282;}.cls-29{stroke:#343f42;}.cls-30{fill:#1f2e34;}.cls-31{fill:#fffcfe;}.cls-32{fill:#303b3e;}.cls-33{fill:#f44d4d;}.cls-34{fill:#f66562;}.cls-35{fill:#d0d6e2;}.cls-36{stroke:#303b3e;}.cls-37{fill:#dadada;}.cls-38{clip-path:url(#clip-path);}.cls-39{stroke:#fff;}.cls-40{stroke:#bdbdbd;stroke-width:2px;}.cls-41{fill:#bdbdbd;}.cls-42{fill:#960002;}.cls-43{fill:#ff031c;}.cls-44{fill:#b97109;}.cls-45{fill:#ff9c0e;}.cls-46{fill:#02782c;}.cls-47{fill:#00de42;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 151.29,
    y1: 110.05,
    x2: 151.29,
    y2: 262.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8ab3ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#8ab3ff",
    stopOpacity: 0.97
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#8ab3ff",
    stopOpacity: 0.89
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#8ab3ff",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#8ab3ff",
    stopOpacity: 0.57
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#8ab3ff",
    stopOpacity: 0.33
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#8ab3ff",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#8ab3ff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10,2.17C9.88,1.49,9.13.82,7.77.4,5.48-.3,2.38-.06.85,1A1.52,1.52,0,0,0,0,2.17H0v0H0L0,76.85c.08.68.83,1.34,2.19,1.76,2.28.71,5.38.46,6.92-.55A1.57,1.57,0,0,0,10,76.85h0v0h0V2.17Z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "Jar_01b",
    "data-name": "Jar_01b",
    viewBox: "0 0 9.26 18.96"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M9.26,4.77h0c0-.65-.75-1.28-2-1.68a8.8,8.8,0,0,0-6.42.5A1.41,1.41,0,0,0,0,4.77H0V16.91H0c0,.65.75,1.28,2.05,1.68a8.8,8.8,0,0,0,6.42-.5,1.41,1.41,0,0,0,.79-1.18h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M8.33,1.64h0c0-.52-.59-1-1.63-1.34A7,7,0,0,0,1.56.7a1.08,1.08,0,0,0-.63.94h0v2h0c0,.51.59,1,1.63,1.34a7,7,0,0,0,5.14-.4,1.1,1.1,0,0,0,.63-.94h0Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 4.63,
    cy: 1.82,
    rx: 1.31,
    ry: 2.96,
    transform: "translate(2.76 6.43) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M9.26,4.77a.24.24,0,0,0,0-.09,1.32,1.32,0,0,1-.76,1.26c-1.42.93-4.3,1.15-6.42.5C.74,6,0,5.41,0,4.76H0V16.91H0c0,.65.75,1.28,2.05,1.68a8.8,8.8,0,0,0,6.42-.5,1.41,1.41,0,0,0,.79-1.18h0V4.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2.05,6.44c-1.3-.4-2-1-2-1.67H0V16.91H0c0,.65.75,1.28,2.05,1.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M8.31,1.56A1.37,1.37,0,0,1,7.43,3a7.21,7.21,0,0,1-5.21.19C1.15,2.8.9,2.1.94,1.55c0,0,0,.06,0,.09h0v2c0,.51.59,1,1.63,1.34a7,7,0,0,0,5.14-.4,1.1,1.1,0,0,0,.63-.94h0v-2h0S8.31,1.59,8.31,1.56Z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "Jars_03",
    "data-name": "Jars_03",
    viewBox: "0 0 55.37 34.92"
  }, /*#__PURE__*/React.createElement("use", {
    width: 9.26,
    height: 18.96,
    transform: "translate(0 15.96)",
    xlinkHref: "#Jar_01b"
  }), /*#__PURE__*/React.createElement("use", {
    width: 9.26,
    height: 18.96,
    transform: "translate(15.37 11.08)",
    xlinkHref: "#Jar_01b"
  }), /*#__PURE__*/React.createElement("use", {
    width: 9.26,
    height: 18.96,
    transform: "translate(30.74 4.88)",
    xlinkHref: "#Jar_01b"
  }), /*#__PURE__*/React.createElement("use", {
    width: 9.26,
    height: 18.96,
    transform: "translate(46.11)",
    xlinkHref: "#Jar_01b"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "Jars_01",
    "data-name": "Jars_01",
    viewBox: "0 0 82.96 48.91"
  }, /*#__PURE__*/React.createElement("use", {
    width: 55.37,
    height: 34.92,
    xlinkHref: "#Jars_03"
  }), /*#__PURE__*/React.createElement("use", {
    width: 55.37,
    height: 34.92,
    transform: "translate(9.31 5.32)",
    xlinkHref: "#Jars_03"
  }), /*#__PURE__*/React.createElement("use", {
    width: 55.37,
    height: 34.92,
    transform: "translate(18.72 9.33)",
    xlinkHref: "#Jars_03"
  }), /*#__PURE__*/React.createElement("use", {
    width: 55.37,
    height: 34.92,
    transform: "translate(27.59 13.99)",
    xlinkHref: "#Jars_03"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "WarningLightOff_01",
    "data-name": "WarningLightOff_01",
    viewBox: "0 0 9.97 79.77"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M10,2.17C9.88,1.49,9.13.82,7.77.4,5.48-.3,2.38-.06.85,1A1.52,1.52,0,0,0,0,2.17H0v0H0L0,76.85c.08.68.83,1.34,2.19,1.76,2.28.71,5.38.46,6.92-.55A1.57,1.57,0,0,0,10,76.85h0v0h0V2.17Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-38"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-39",
    x1: 1.65,
    y1: 2.49,
    x2: 1.65,
    y2: 79.77
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-40",
    x1: 7.28,
    y1: 2.49,
    x2: 7.28,
    y2: 79.77
  })), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-41",
    cx: 4.99,
    cy: 2.22,
    rx: 2.2,
    ry: 4.99,
    transform: "translate(2.72 7.18) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M10,4.22a1.47,1.47,0,0,1-.83,1.32c-1.54,1-4.64,1.24-6.92.54C.78,5.64,0,5,0,4.25L0,13.5c.07.67.82,1.34,2.18,1.76,2.29.7,5.38.46,6.92-.55A1.57,1.57,0,0,0,10,13.5Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-43",
    x: 3.38,
    y: 7.97,
    width: 3.16,
    height: 5.42
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M10,13.39a1.47,1.47,0,0,1-.83,1.32c-1.54,1-4.63,1.24-6.92.54C.78,14.81,0,14.13,0,13.42l0,9.25c.07.68.82,1.34,2.18,1.76,2.29.71,5.38.46,6.92-.55A1.52,1.52,0,0,0,10,22.67Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 3.38,
    y: 17.15,
    width: 3.16,
    height: 5.42
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M10,22.57a1.46,1.46,0,0,1-.83,1.31c-1.54,1-4.63,1.24-6.92.54C.78,24,0,23.3,0,22.59l0,9.25c.07.68.82,1.34,2.18,1.76,2.29.71,5.38.46,6.92-.54A1.54,1.54,0,0,0,10,31.84Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 3.38,
    y: 26.21,
    width: 3.16,
    height: 5.42
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "Vask_Machine_01a",
    "data-name": "Vask_Machine_01a",
    viewBox: "0 0 302.09 359.05"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("image", {
    width: 299,
    height: 169,
    transform: "translate(3.09 190.05)",
    xlinkHref: "data:image/png;base64,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"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "126.35 304.2 126.35 316.2 133 320.05 142.97 316.8 142.97 307.8 126.35 304.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "46.55 261.13 46.55 270.13 53.2 273.97 63.17 270.73 63.17 261.73 46.55 261.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "242.72 266.39 242.72 278.39 249.41 282.26 259.35 278.99 259.35 266.99 242.72 266.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "56.52 101.89 56.52 185.89 162.92 151.32 162.92 67.32 56.52 101.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M43.22,43.21v219l133-43.21V0Zm119.7,108.11L56.52,185.89v-84l106.4-34.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M43.22,43.21v219L133,314V95Zm83.13,219L49.87,218.05v-108l76.48,44.16Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "182.87 141.84 182.77 159.87 176.22 162 176.22 144.15 182.87 141.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "93.1 245.18 123.02 262.46 123.02 301.69 93.1 284.18 93.1 245.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "0 225.26 69.82 265.57 69.82 271.57 0 231.26 0 225.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "3.33 218.18 73.15 258.49 69.82 265.57 0 225.26 3.33 218.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "53.11 201.88 219.45 147.96 289.27 188.27 73.15 258.49 3.33 218.18 53.11 201.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "289.27 188.27 73.15 258.49 69.82 265.57 69.82 271.57 76.47 275.41 292.6 205.19 295.92 198.11 295.92 192.11 289.27 188.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "13.3 223.94 229.42 153.72 279.3 182.51 63.17 252.73 13.3 223.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "13.3 223.94 63.17 252.73 59.85 259.81 9.97 231.02 13.3 223.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "9.97 231.02 59.85 259.81 59.85 265.81 9.97 237.02 9.97 231.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M252.7,119.15v84L146.3,237.72v-84ZM126.35,154.21,49.87,110.05v108l76.48,44.16Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "43.22 43.21 133 95.05 266 51.83 176.22 0 43.22 43.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "93.1 84.01 123.02 101.29 123.02 140.51 93.1 123.01 93.1 84.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "53.2 60.97 83.12 78.25 83.12 117.48 53.2 99.97 53.2 60.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "53.2 105.97 3.33 77.18 9.97 75.02 59.85 103.81 53.2 105.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "59.85 160.81 59.85 103.81 53.2 105.97 53.2 162.97 59.85 160.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "3.33 77.18 53.2 105.97 53.2 162.97 3.33 134.18 3.33 77.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "6.65 85.1 49.87 110.05 49.87 149.05 6.65 124.1 6.65 85.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "26.6 30.62 26.6 84.62 33.25 88.45 33.25 34.45 26.6 30.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "39.77 38.22 39.77 92.29 33.25 88.45 33.25 34.45 39.77 38.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "33.25 19.45 53.2 12.97 59.85 16.81 39.9 23.29 33.25 19.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "46.55 30.13 66.5 23.65 59.85 16.81 39.9 23.29 46.55 30.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "59.85 25.81 59.98 46.81 66.63 50.65 66.63 23.65 59.85 25.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "73.15 21.49 73.15 48.49 66.63 50.65 66.63 23.65 73.15 21.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "39.9 23.29 33.25 34.45 39.77 38.22 46.55 30.13 39.9 23.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "33.25 19.45 26.6 30.62 33.25 34.45 39.9 23.29 33.25 19.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "59.85 16.81 66.5 23.65 73.15 21.49 73.15 18.49 66.5 14.65 59.85 16.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "53.2 12.97 59.85 16.81 66.5 14.65 59.85 10.81 53.2 12.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "9.97 90.02 46.55 111.13 46.55 144.13 9.97 123.02 9.97 90.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "39.9 113.29 39.83 134.25 29.86 128.49 29.86 107.49 39.9 113.29"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-26",
    x1: 13.3,
    y1: 100.94,
    x2: 26.5,
    y2: 108.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-26",
    x1: 13.3,
    y1: 106.94,
    x2: 26.5,
    y2: 114.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-26",
    x1: 13.3,
    y1: 112.94,
    x2: 26.5,
    y2: 120.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-26",
    x1: 13.3,
    y1: 118.94,
    x2: 26.5,
    y2: 126.6
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "289.27 203.27 76.47 272.41 73.15 270.49 73.15 264.49 76.47 260.41 289.27 191.27 292.57 193.17 292.57 199.17 289.27 203.27"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-15",
    cx: 79.8,
    cy: 265.27,
    rx: 3.45,
    ry: 2.5,
    transform: "translate(-173.96 154.17) rotate(-49.61)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-15",
    cx: 89.77,
    cy: 262.03,
    rx: 3.45,
    ry: 2.5,
    transform: "matrix(0.65, -0.76, 0.76, 0.65, -167.98, 160.63)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-15",
    cx: 99.75,
    cy: 258.79,
    rx: 3.45,
    ry: 2.5,
    transform: "translate(-162 167.09) rotate(-49.61)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-15",
    cx: 109.72,
    cy: 255.54,
    rx: 3.45,
    ry: 2.5,
    transform: "matrix(0.65, -0.76, 0.76, 0.65, -156.02, 173.54)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-15",
    cx: 119.7,
    cy: 252.3,
    rx: 3.45,
    ry: 2.5,
    transform: "translate(-150.04 180) rotate(-49.61)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-15",
    cx: 266,
    cy: 204.77,
    rx: 3.45,
    ry: 2.5,
    transform: "translate(-62.32 274.7) rotate(-49.61)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-15",
    cx: 275.97,
    cy: 201.53,
    rx: 3.45,
    ry: 2.5,
    transform: "matrix(0.65, -0.76, 0.76, 0.65, -56.34, 281.16)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-15",
    cx: 285.95,
    cy: 198.29,
    rx: 3.45,
    ry: 2.5,
    transform: "translate(-50.36 287.61) rotate(-49.61)"
  }), /*#__PURE__*/React.createElement("use", {
    width: 82.96,
    height: 48.91,
    transform: "translate(37.4 196.15)",
    xlinkHref: "#Jars_01"
  }), /*#__PURE__*/React.createElement("use", {
    width: 82.96,
    height: 48.91,
    transform: "translate(110.87 171.11)",
    xlinkHref: "#Jars_01"
  }), /*#__PURE__*/React.createElement("use", {
    width: 82.96,
    height: 48.91,
    transform: "translate(184.91 146.9)",
    xlinkHref: "#Jars_01"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M133,95V314l133-43.21v-219ZM252.7,203.15,146.3,237.72v-84l106.4-34.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M146.69,264.6l46.16-15v36L146.3,300.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M206.54,245.15l46.16-15v36l-46.55,15.13Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "146.3 243.72 146.3 258.72 252.7 224.15 252.7 209.15 146.3 243.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "156.27 111.48 192.92 99.58 192.85 129.6 156.27 141.48 156.27 111.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "149.62 101.64 209.47 82.2 209.47 127.2 149.62 146.64 149.62 101.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "222.77 89.88 239.4 84.47 239.4 120.53 222.77 125.88 222.77 89.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "226.1 91.8 236.07 88.55 235.69 106.68 226.1 109.8 226.1 91.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "226.1 112.8 236.07 109.55 236.07 118.55 226.1 121.8 226.1 112.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "179.55 109.92 189.52 106.68 189.52 124.68 179.55 127.92 179.55 109.92"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-26",
    x1: 162.92,
    y1: 115.32,
    x2: 176.22,
    y2: 111
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-26",
    x1: 162.92,
    y1: 121.32,
    x2: 176.22,
    y2: 117
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-26",
    x1: 162.92,
    y1: 127.32,
    x2: 176.22,
    y2: 123
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-26",
    x1: 162.92,
    y1: 133.32,
    x2: 176.22,
    y2: 129
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "133 95.05 132.9 314.05 126.35 310.2 126.35 91.2 133 95.05"
  }), /*#__PURE__*/React.createElement("use", {
    width: 9.98,
    height: 79.77,
    transform: "translate(136.32)",
    xlinkHref: "#WarningLightOff_01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "146.3 153.72 146.3 237.72 252.7 203.15 252.7 119.15 146.3 153.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "194.54 99.05 194.54 129.05 204.51 125.81 204.51 95.81 194.54 99.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M10.79,135.54a3.52,3.52,0,0,1-1.72-.5,5.8,5.8,0,0,1-2.83-4.56A2.31,2.31,0,0,1,8.56,128a3.43,3.43,0,0,1,1.72.51,5.78,5.78,0,0,1,2.83,4.55A2.31,2.31,0,0,1,10.79,135.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M11.91,133.05a4.62,4.62,0,0,0-2.23-3.51,1.84,1.84,0,0,0-1.54-.27h0l-.05,0-3.27,1.06h0a1.17,1.17,0,0,0-.7,1.21,4.63,4.63,0,0,0,2.23,3.52,1.87,1.87,0,0,0,1.51.27l3.33-1.08A1.17,1.17,0,0,0,11.91,133.05Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-34",
    cx: 6.35,
    cy: 132.85,
    rx: 1.68,
    ry: 2.96,
    transform: "translate(-78.58 30.5) rotate(-36.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M20.76,141.3a3.48,3.48,0,0,1-1.71-.5,5.82,5.82,0,0,1-2.83-4.56,2.3,2.3,0,0,1,2.32-2.49,3.4,3.4,0,0,1,1.71.51,5.78,5.78,0,0,1,2.83,4.55A2.3,2.3,0,0,1,20.76,141.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M21.88,138.81a4.62,4.62,0,0,0-2.23-3.51,1.81,1.81,0,0,0-1.53-.27h-.06l-3.27,1.07h0a1.18,1.18,0,0,0-.69,1.21,4.61,4.61,0,0,0,2.23,3.52,1.86,1.86,0,0,0,1.5.27L21.16,140A1.17,1.17,0,0,0,21.88,138.81Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-34",
    cx: 16.33,
    cy: 138.61,
    rx: 1.68,
    ry: 2.96,
    transform: "translate(-80.04 37.65) rotate(-36.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M29.08,145.8a3.15,3.15,0,0,1-1.57-.47,5.56,5.56,0,0,1-2.68-4.3,2,2,0,0,1,2-2.18,3.1,3.1,0,0,1,1.56.46,5.53,5.53,0,0,1,2.68,4.3A2,2,0,0,1,29.08,145.8Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-35",
    cx: 27.96,
    cy: 142.32,
    rx: 1.68,
    ry: 2.96,
    transform: "translate(-79.93 45.39) rotate(-36.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M37.39,150.6a3.18,3.18,0,0,1-1.57-.47,5.53,5.53,0,0,1-2.68-4.29,2,2,0,0,1,2-2.19,3.2,3.2,0,0,1,1.56.46,5.54,5.54,0,0,1,2.69,4.3A2,2,0,0,1,37.39,150.6Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-35",
    cx: 36.27,
    cy: 147.12,
    rx: 1.68,
    ry: 2.96,
    transform: "translate(-81.15 51.35) rotate(-36.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M45.7,155.39a3.1,3.1,0,0,1-1.56-.46,5.53,5.53,0,0,1-2.68-4.3,2,2,0,0,1,2-2.19,3.15,3.15,0,0,1,1.57.47,5.54,5.54,0,0,1,2.68,4.3A2,2,0,0,1,45.7,155.39Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-35",
    cx: 44.59,
    cy: 151.92,
    rx: 1.68,
    ry: 2.96,
    transform: "translate(-82.36 57.31) rotate(-36.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M159.09,107.75a2.72,2.72,0,0,1-2.74-2.82,4.53,4.53,0,0,1,3.06-4.1,3.66,3.66,0,0,1,1.06-.17,2.71,2.71,0,0,1,2.74,2.82,4.49,4.49,0,0,1-3.06,4.09A3.28,3.28,0,0,1,159.09,107.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M164.59,104l-3.21-1.84a1.77,1.77,0,0,0-1.6-.17,3.37,3.37,0,0,0-2.23,3,1.62,1.62,0,0,0,.53,1.25l3.58,2.1a1.83,1.83,0,0,0,1.45.07,3.35,3.35,0,0,0,2.23-2.95A1.55,1.55,0,0,0,164.59,104Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-34",
    cx: 163.11,
    cy: 106.12,
    rx: 2.62,
    ry: 1.9,
    transform: "translate(-23.41 161.6) rotate(-49.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M169.07,104.51a2.73,2.73,0,0,1-2.74-2.82,4.51,4.51,0,0,1,3.06-4.1,3.26,3.26,0,0,1,1.06-.17,2.72,2.72,0,0,1,2.74,2.82,4.51,4.51,0,0,1-3.06,4.09A3.32,3.32,0,0,1,169.07,104.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M174.56,100.74l-3.2-1.85a1.81,1.81,0,0,0-1.6-.16,3.36,3.36,0,0,0-2.23,3,1.59,1.59,0,0,0,.53,1.25l3.58,2.1a1.81,1.81,0,0,0,1.44.07,3.35,3.35,0,0,0,2.23-3A1.55,1.55,0,0,0,174.56,100.74Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-34",
    cx: 173.08,
    cy: 102.88,
    rx: 2.62,
    ry: 1.9,
    transform: "translate(-17.43 168.06) rotate(-49.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M177.14,101.59a2.4,2.4,0,0,1-2.44-2.53,4.26,4.26,0,0,1,2.85-3.81,3.34,3.34,0,0,1,1-.16A2.4,2.4,0,0,1,181,97.62a4.28,4.28,0,0,1-2.85,3.81A3.39,3.39,0,0,1,177.14,101.59Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-35",
    cx: 177.83,
    cy: 98.34,
    rx: 2.62,
    ry: 1.9,
    transform: "translate(-12.3 170.07) rotate(-49.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M183.79,99.42a2.4,2.4,0,0,1-2.44-2.52,4.26,4.26,0,0,1,2.85-3.81,3.34,3.34,0,0,1,1-.16,2.4,2.4,0,0,1,2.44,2.52,4.28,4.28,0,0,1-2.85,3.82A3.37,3.37,0,0,1,183.79,99.42Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-35",
    cx: 184.48,
    cy: 96.18,
    rx: 2.62,
    ry: 1.9,
    transform: "translate(-8.31 174.38) rotate(-49.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M190.44,97.26A2.4,2.4,0,0,1,188,94.74a4.26,4.26,0,0,1,2.85-3.81,3.34,3.34,0,0,1,1-.16,2.4,2.4,0,0,1,2.44,2.52,4.27,4.27,0,0,1-2.85,3.81A3.08,3.08,0,0,1,190.44,97.26Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-35",
    cx: 191.13,
    cy: 94.02,
    rx: 2.62,
    ry: 1.9,
    transform: "translate(-4.32 178.68) rotate(-49.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M199,106.48a2.4,2.4,0,0,1-2.44-2.52,4.26,4.26,0,0,1,2.85-3.81,3.39,3.39,0,0,1,1-.16,2.4,2.4,0,0,1,2.44,2.52,4.27,4.27,0,0,1-2.85,3.82A3.32,3.32,0,0,1,199,106.48Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-35",
    cx: 199.68,
    cy: 103.24,
    rx: 2.62,
    ry: 1.9,
    transform: "translate(-8.34 188.44) rotate(-49.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M199,115.48a2.4,2.4,0,0,1-2.44-2.52,4.26,4.26,0,0,1,2.85-3.81,3.39,3.39,0,0,1,1-.16,2.4,2.4,0,0,1,2.44,2.52,4.27,4.27,0,0,1-2.85,3.82A3.32,3.32,0,0,1,199,115.48Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-35",
    cx: 199.68,
    cy: 112.24,
    rx: 2.62,
    ry: 1.9,
    transform: "translate(-15.19 191.61) rotate(-49.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M199,124.48a2.4,2.4,0,0,1-2.44-2.52,4.26,4.26,0,0,1,2.85-3.81,3.39,3.39,0,0,1,1-.16,2.4,2.4,0,0,1,2.44,2.52,4.27,4.27,0,0,1-2.85,3.82A3.32,3.32,0,0,1,199,124.48Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-35",
    cx: 199.68,
    cy: 121.24,
    rx: 2.62,
    ry: 1.9,
    transform: "translate(-22.05 194.78) rotate(-49.61)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-36",
    x1: 196.17,
    y1: 109.08,
    x2: 202.82,
    y2: 106.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-36",
    x1: 196.17,
    y1: 117.91,
    x2: 202.82,
    y2: 115.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-36",
    x1: 196.17,
    y1: 127.03,
    x2: 202.82,
    y2: 124.87
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vask_Sterilisation",
    "data-name": "Vask & Sterilisation"
  }, /*#__PURE__*/React.createElement("use", {
    width: 302.09,
    height: 359.05,
    xlinkHref: "#Vask_Machine_01a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWashingMachine1);
export default __webpack_public_path__ + "static/media/washing-machine-1.2cc6424df6843b2305871a9a04e224dd.svg";
export { ForwardRef as ReactComponent };